import React from "react";
import styles from "./Verticals.module.css";
import logoImage from "../../assets/images/ourVerticals/logo.png";
import SectionHeader from "../../components/sectionHeader/index";

const verticalsData = [
  {
    title: "Securities",
    description:
      "Established in 2007 as the brokerage arm of Cairo Capital, CCS combines deep market expertise with transparent, fully FRA-authorized operations. With EGP 100 million in issued capital, CCS provides dynamic and compliant brokerage services to retail and institutional investors across Egypt.",
    statTitle: "The 5th",
    statSubtitle: "Ranked for the main market and obtained 5% Market Share",
  },
  {
    title: "Asset Management",
    description:
      "Since 1998, we have been a trusted portfolio manager to Egypt’s largest government institutions, including the Social Insurance Authority, Misr Insurance Company, and the Medical Insurance Authority. Our disciplined approach and deep market insight have made us a leader in institutional asset management.",
    statTitle: "Double AUM",
    statSubtitle: "in 3 years",
  },
  {
    title: "Private Equity",
    description:
      "We manage the first private equity fund dedicated to Egypt's industrial sector and the first state-backed fund. With a track record of over 180 deals reviewed, 8 portfolio investments, and 7 private equity funds developed, CC Private Equity combines strategic insight with executional excellence.",
    statTitle: "+60%",
    statSubtitle: "of NIIF’s targeted investments are already secured",
  },
  {
    title: "Start-up ventures",
    description:
      "Our venture capital arm invests in high-potential fintech and software startups that strengthen Cairo Capital’s digital capabilities. We focus on early-stage innovation that drives operational efficiency, enhances service delivery, and redefines the future of financial services.",
    statTitle: "Fosters successful start ups",
    statSubtitle: "",
  },
];

const Verticals = () => {
  return (
    <section className={styles.verticals}>
      <SectionHeader title="Our Verticals" />
      <div className={styles.cards}>
        {verticalsData.map((v, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.logoWrapper}>
              <div>
                <img src={logoImage} alt={v.title} />
              </div>
              <div className={styles.container}>
                <div className={styles.header}>
                  <span className={styles.title}>{v.title}</span>
                </div>
              </div>
            </div>
            <div className={styles.cardText}>
              <p className={styles.cardDesc}>{v.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.stats}>
        {verticalsData.map((v, i) => (
          <div key={i} className={styles.statCard}>
            <span className={styles.statLabel}>{v.title}</span>
            <h4 className={styles.statTitle}>{v.statTitle}</h4>
            {v.statSubtitle && (
              <p className={styles.statDesc}>{v.statSubtitle}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Verticals;
